import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

// feat_299 — "Ver como usuario". Variable de MÓDULO (no estado de React):
// los interceptors de useAuth se registran en cada render y axios los ejecuta
// en orden INVERSO al de registro → una clausura sobre estado React mandaría
// siempre el valor del primer render (stale). Este interceptor se registra una
// sola vez al importar el módulo → corre último → su valor gana, y la variable
// mutable siempre está fresca.
let viewAsUserId = null;

export const setViewAsHeader = id => {
	viewAsUserId = id ? String(id) : null;
};

api.interceptors.request.use(config => {
	if (viewAsUserId) {
		config.headers["X-View-As-User-Id"] = viewAsUserId;
	} else {
		delete config.headers["X-View-As-User-Id"];
	}
	return config;
});

export default api;
